var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_551_34373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 27C54 12.0867 41.9133 0 27 0C12.0867 0 0 12.0867 0 27C0 40.4789 9.87187 51.648 22.7812 53.673V34.8047H15.9258V27H22.7812V21.0516C22.7812 14.2857 26.8102 10.5469 32.9801 10.5469C35.9332 10.5469 39.0234 11.0742 39.0234 11.0742V17.7188H35.6168C32.2629 17.7188 31.2188 19.8018 31.2188 21.9375V27H38.707L37.51 34.8047H31.2188V53.673C44.1281 51.648 54 40.4789 54 27Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.51 34.8047L38.707 27H31.2188V21.9375C31.2188 19.8018 32.2629 17.7188 35.6168 17.7188H39.0234V11.0742C39.0234 11.0742 35.9332 10.5469 32.9801 10.5469C26.8102 10.5469 22.7812 14.2857 22.7812 21.0516V27H15.9258V34.8047H22.7812V53.673C24.1576 53.8893 25.5656 54 27 54C28.4344 54 29.8424 53.8893 31.2188 53.673V34.8047H37.51Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_551_34373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f891a49fa4260a6e10de226448d19f0f.svg";
export { ForwardRef as ReactComponent };